module.exports = __webpack_public_path__ + "img/sports-gamebg.41b25946.png";